<template lang='pug'>
v-app
  v-app-bar(
    app
    dark
    flat
  )
    v-btn(
      text
      href='https://foodfastfit.com/'
    )
      | #[v-icon(left) mdi-pound] FOODFASTFIT
    v-spacer
    TheUserIcon
  v-main
    Progress(
      v-slot='{ start, stop }'
    )
      Uid
        InitFatsecretApi(
          @start='start'
          @stop='stop'
        )
          router-view
</template>

<script>
import InitFatsecretApi from '@thomasphan/vue-components/src/components/InitFatsecretApi.vue';
import Progress from '@thomasphan/vue-components/src/components/Progress.vue';
import TheUserIcon from '@thomasphan/vue-components/src/components/TheUserIcon.vue';
import Uid from '@thomasphan/vue-components/src/components/Uid.vue';

export default
{
  components:
  {
    InitFatsecretApi,
    Progress,
    TheUserIcon,
    Uid,
  }
};
</script>